'use client';

import { usePathname } from 'next/navigation';

import { Spinner } from '@/components/ui/spinner';

import { AdminNav } from './components/AdminNav';
import { useAdminGuard } from './hooks/useAdminGuard';

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // ログイン画面はガード対象外(リダイレクトループ防止)
  if (pathname === '/admin/login') {
    return <>{children}</>;
  }

  return <GuardedShell>{children}</GuardedShell>;
}

function GuardedShell({ children }: { children: React.ReactNode }) {
  const { me, isLoading } = useAdminGuard();

  if (isLoading || !me) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminNav me={me} />
      <main className="flex-1 overflow-x-auto px-8 py-8">{children}</main>
    </div>
  );
}
